module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAMAAACw0Z1uAAAAUVBMVEUAAAD///+/v7/f39/GxsbGxsbT09PQ0NDMzMzR0dHNzc3Ozs7Ozs7Q0NDPz8/Ozs7Pz8/Ozs7Ozs7Pz8/Ozs7Ozs7Ozs7Ozs7Ozs7Pz8/Ozs7dSIgfAAAAGnRSTlMAAwQICRIdKy09UWiBgZqxxNXc3uDu7/b8/i/vnXUAAABmSURBVBjTddDJDoAgDARQQdxAWdyA+f8P9TptYm8vIS0zw6DGWqHzmpk3ykReHmRH3iqSIfuGyOtCx8He0QM7onmiSagb2WU8K3kqeMc/ysdqlTx0iG+Ejv0vggwo46tyVHWqWDkfs9EGJU+A0QoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_right.png
// module id = cwTc
// module chunks = 2